export default __webpack_public_path__ + "702da3d112eb8f43bd6728689b891d8a.png";